// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.document-img {
  display: block;
  margin: 25px auto;
}

.form-group-button {
  margin-top: 25px;
}

.sub-title-black {
  color: black;
}

.wc-container .wc-container-in .softToken-title {
  margin-bottom: 25px !important;
}
.wc-container .wc-container-in .vu-pt-md-0 {
  padding: 0 12px !important;
}
.wc-container .wc-container-in .vu-pl-5 {
  padding: 0 12px !important;
}
.wc-container .wc-container-in button#validar {
  background: #2b8f14 !important;
  background-color: #2b8f14 !important;
  border: none;
}
.wc-container .wc-container-in #vu-second-factor-input {
  font-size: 17px !important;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
